<template>
    <div class="dashboard_traffic card">
      <div class="header">
        <div class="wrap_select">
          <div class="form_select">
            <fg-input
                type="text"
                v-model="filter.q"
                :placeholder="translate('search')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="wrap_select"></div>
        <div class="wrap_select"></div>
        <div class="wrap_select"></div>
        <div class="wrap_select"></div>
      </div>

      <div class="response_table" >
        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th
                  class="pointer"
                  @click="change_filter('mno_name')"
                  :class="{ selected: filter_type === 'mno_name' }"
                  scope="col"
              >
                {{ translate("dashboard.simcards_traffic.mno") }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('tariff_name')"
                  :class="{ selected: filter_type === 'tariff_name' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.tariff_name') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('imsi')"
                  :class="{ selected: filter_type === 'imsi' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.imsi') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('iccid')"
                  :class="{ selected: filter_type === 'iccid' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.iccid') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>

              <th
                  class="pointer"
                  @click="change_filter('cost')"
                  :class="{ selected: filter_type === 'cost' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.cost') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('value')"
                  :class="{ selected: filter_type === 'value' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.value') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('limit')"
                  :class="{ selected: filter_type === 'limit' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.limit') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('ts_update')"
                  :class="{ selected: filter_type === 'ts_update' }"
                  scope="col"
              >
                {{ translate('dashboard.simcards_traffic.ts_update') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
            </tr>
          </thead>

          <tbody>
          <tr v-for="(traffic, key) in traffic_stats" :key="key" class="traffic_item">
            <td :data-label="translate('dashboard.simcards_traffic.mno')">
              {{ traffic.mno_name }}
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.tariff_name')">
              {{ traffic.tariff_name }}
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.imsi')" >
              <router-link :to="{path: `/simcard_profile/${traffic.imsi}/profile`}">
                {{ traffic.imsi }}
              </router-link>
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.iccid')" >
              <router-link :to="{path: `/simcard_devices_list?&msisdn_imsi_iccid=${traffic.iccid}`}">
                {{ traffic.iccid }}
              </router-link>
              <span class="mdi mdi-content-copy pointer" @click="copy_iccid(traffic.iccid)" />
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.cost')">
              {{ traffic.cost }}
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.value')">
              {{ traffic.value }}
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.limit')">
              {{ traffic.limit }}
            </td>
            <td :data-label="translate('dashboard.simcards_traffic.ts_update')" :class="isMoreThanDay(traffic.ts_update) ? 'old' : ''">
              {{ get_date(traffic.ts_update) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>

export default {
  name: 'SimcardsTraffic',
  data () {
    return {
      simcards_traffic_stat: [],
      filter_asc: "asc",
      filter_type: "",
      filter:{
        q: ""
      }
    }
  },

  computed:{
    traffic_stats(){
      let traffic_stats = [...this.simcards_traffic_stat];
      return traffic_stats.sort(this.compareNumbers);
    },
  },

  created () {
    this.dashboard_simcards_traffic()
  },

  watch:{

  },

  methods: {
    isMoreThanDay(timestamp) {
      return Date.now() - Number(timestamp) * 1000 > 24 * 60 * 60 * 1000;
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.dashboard_simcards_traffic, 300)
    },
    copy_iccid(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    dashboard_simcards_traffic(){
      this.$http.v1.dashboardSimcardsTraffic(this.filter, (response) => {
        this.simcards_traffic_stat = response.data
      });
    },
  },
}

</script>

<style scoped lang="scss">
.dashboard_traffic{
  padding: 0;
  margin-top: 10px;
  height: calc(100% - 10px);
  .header{
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .wrap_select{
      width: 100%;
      flex-direction: column;
      .form_select{
        width: 100%;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
    }
  }
  .response_table{
    padding: 10px;
    height: calc(100% - 80px);
    tbody{
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
    .old{
      background-color: #F3BB45;
    }
  }
}

</style>
